module.exports = __webpack_public_path__ + "img/wall3.02493c2c.png";